/**
 * useAuthSafe.js
 * Safe wrapper around useAuth() that returns a mock object
 * when AuthProvider is not present (bypass/dev mode).
 */

import { useContext } from 'react';
import { AuthContext } from 'react-oidc-context';

export default function useAuthSafe() {
  const context = useContext(AuthContext);

  // AuthProvider not in tree — return safe mock object
  if (!context) {
    return {
      user: null,
      isAuthenticated: false,
      isLoading: false,
      error: null,
      activeNavigator: undefined,
      signinRedirect: () => {},
      signoutRedirect: () => {},
    };
  }

  return context;
}